<p-toast key="selectionItem"></p-toast>
<p-menu appendTo="body" #menuContextuelAjout popup="popup" [model]="contenuMenuContextuelAjout"></p-menu>

<p-blockUI [blocked]="blocked">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-blockUI>


<p-card *ngIf="!EstCharge()">
    <app-loading [title]="'Chargement de l\'inventaire'" [httpEvent]="loadingEvent"
        [error]="loadingError"></app-loading>
</p-card>

<div #contenu *ngIf="EstCharge()" min-height="300px">

    <!------------ TYPE SAISIE ET CATÉGORIE ------------>
    <div class="mb-3">
        @if (!itemSelectionne) {
        <div class="flex flex-wrap gap-3 justify-content-between align-items-center">
            <div class="flex-grow-1">
                <p-selectButton (onChange)="surChangementCategorie()" [options]="listeCategories"
                    [(ngModel)]="selectionCategorie" optionLabel="valeur" styleClass="w-full">
                </p-selectButton>
            </div>
            <div class="flex flex-wrap align-items-end gap-2">
                @if (nouveauDisponible && estAutorise('item_creer')) {
                <p-button (click)="nouvelItem($event)" label="Nouvel Item" pTooltip="Créer un nouvel item inventorié"
                    icon="pi pi-plus" severity="success" tooltipPosition="left">
                </p-button>
                }
                @if (estTypeSaisieDisponible) {
                <p-button (click)="ajouterItemDivers('')" label="Nouveau divers"
                    pTooltip="Créer un nouvel item non-inventorié" outlined icon="pi pi-plus" tooltipPosition="left">
                </p-button>
                }
            </div>
        </div>
        }
    </div>

    <!------------ LISTE SÉLECTION INVENTAIRE ------------>

    <div class="fluid formgrid grid" *ngIf="!itemSelectionne">
        <div class="col-12">

            <p-table #dt [value]="items" [columns]="selectedColumns" dataKey="itemId" [responsive]="true"
                styleClass="p-datatable-sm p-datatable-striped mobile-table" [(contextMenuSelection)]="selectionItem"
                [contextMenu]="cm" [rowHover]="true" [rows]="10" [paginator]="true" [filterDelay]="0"
                [globalFilterFields]="['numero','description','statut','categorie','sousCategorie','marque','modele','noSerie','noPlaque','produitsFournisseurChaine','ancienNumero']">
                <ng-template pTemplate="caption">
                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                        <span class="p-input-icon-left flex-grow-1">
                            <i class="pi pi-search"></i>
                            <input #rechercheItem pInputText type="text" class="w-full"
                                (input)="dt.filterGlobal($event.target.value, 'contains')"
                                (keyup.enter)="surEntreeRecherche()" autofocus
                                placeholder="Recherchez un numéro, description, marque, modèle, etc..." />
                        </span>
                        <div class="w-full md:w-auto">
                            <p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="selectedColumns"
                                optionLabel="entete" (onChange)="surChangementColonnes($event)"
                                selectedItemsLabel="{0} colonnes sélectionnés" [style]="{minWidth: '100%'}"
                                styleClass="w-full md:w-auto" placeholder="Colonnes...">
                            </p-multiSelect>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>

                        <th pSortableColumn="numero" *ngIf="afficherColonneNumero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="numero"></p-sortIcon>
                                <p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="description">
                            <div class="flex justify-content-between align-items-center">
                                Description
                                <p-sortIcon field="description"></p-sortIcon>
                                <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="afficherColonneStatut">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
                                    [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                            (onChange)="filter($event.value)" optionLabel="name">
                                            <ng-template let-option pTemplate="item">
                                                <div class="multiselect-representative-option">

                                                    <span class="ml-1">{{option.nom}}</span>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="quantite" *ngIf="afficherColonneInventaire">
                            <div class="flex justify-content-between align-items-center">
                                Quantité
                                <p-sortIcon field="quantite"></p-sortIcon>
                                <p-columnFilter type="number" field="quantite" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('categorie')" pSortableColumn="categorie.nom">
                            <div class="flex justify-content-between align-items-center">
                                Catégorie
                                <p-sortIcon field="categorie.nom"></p-sortIcon>
                                <p-columnFilter #filtreCategorie field="categorie.nom" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-multiSelect #champFiltreCategorie [ngModel]="value" [options]="categories"
                                            placeholder="Any" (onChange)="filter($event.value)" optionLabel="name">
                                            <ng-template let-option pTemplate="item">
                                                <div class="multiselect-representative-option">
                                                    <span class="ml-1">{{option}}</span>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('sousCategorie')" pSortableColumn="sousCategorie.nom">
                            <div class="flex justify-content-between align-items-center">
                                Sous-catégorie
                                <p-sortIcon field="sousCategorie.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="sousCategorie" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('marque')" pSortableColumn="modele">
                            <div class="flex justify-content-between align-items-center">
                                Marque
                                <p-sortIcon field="modele"></p-sortIcon>
                                <p-columnFilter type="text" field="modele" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('modele')" pSortableColumn="modele">
                            <div class="flex justify-content-between align-items-center">
                                Modèle
                                <p-sortIcon field="modele"></p-sortIcon>
                                <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>

                        <th *ngIf="EstColonneSelectionnee('noProduit')">
                            <div class="flex justify-content-between align-items-center">
                                No pièce fournisseur

                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('emplacement')" pSortableColumn="emplacement">
                            <div class="flex justify-content-between align-items-center">
                                Emplacement
                                <p-sortIcon field="emplacement"></p-sortIcon>
                                <p-columnFilter type="text" field="emplacement" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th style="max-width: 6rem" alignFrozen="right" pFrozenColumn frozen></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-columns="columns">
                    <tr [pContextMenuRow]="item">
                        <td *ngIf="afficherColonneNumero" data-label="Numéro">{{item.numero}}
                        </td>
                        <td data-label="Description">
                            <div class="flex align-items-center gap-2">
                                <div *ngIf="item.photoId">
                                    @defer (on viewport) {
                                    <app-image-loader [documentId]="item.photoId" [width]="40" [height]="40"
                                        [title]="item.numero"></app-image-loader>
                                    }
                                    @placeholder {
                                    <div class="flex align-items-center justify-content-center"
                                        style="height: 40px; width: 40px;">
                                        <p-skeleton width="40px" height="40px"></p-skeleton>
                                    </div>
                                    }
                                </div>
                                <span>{{item.description}}</span>
                            </div>
                        </td>
                        <td *ngIf="afficherColonneStatut" data-label="Statut">
                            <span [class]="'statut ' + item.statut.nom.toLowerCase()">
                                {{item.statut.nom}}
                            </span>
                        </td>
                        <td *ngIf="afficherColonneInventaire" data-label="Quantité">
                            <span [ngClass]="item.quantite > 0 ? 'inventaire disponible' : 'inventaire nondisponible'">
                                {{item.quantite}}
                            </span>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('categorie')" data-label="Catégorie">
                            {{item.categorie.nom}}
                        </td>
                        <td *ngIf="EstColonneSelectionnee('sousCategorie')" data-label="Sous-catégorie">
                            {{item.sousCategorie?.nom}}
                        </td>
                        <td *ngIf="EstColonneSelectionnee('marque')" data-label="Marque">
                            {{item.marque}}
                        </td>
                        <td *ngIf="EstColonneSelectionnee('modele')" data-label="Modèle">
                            {{item.modele}}
                        </td>
                        <td *ngIf="EstColonneSelectionnee('noProduit')" data-label="No pièce"
                            style="white-space: pre-line;">
                            {{item.produitsFournisseurChaine}}
                        </td>
                        <td *ngIf="EstColonneSelectionnee('emplacement')" data-label="Emplacement">
                            {{item.emplacement | nomEmplacement}}
                        </td>
                        <td data-label="Actions" alignFrozen="right" pFrozenColumn frozen style="max-width: 6rem">
                            <p-buttonGroup>
                                <p-button [disabled]="(estTypeRequisition() || estTypeCommande()) && item.estLie"
                                    icon="pi pi-check" severity="success" tooltipPosition="left"
                                    (click)="surSelectionItemInventaire(item)"
                                    pTooltip="{{item.employe ? 'Cet item est emprunté par ' + item.employe.nom + ' ' + item.employe.prenom + ' veuillez le retourner avant de le sélectionner': 'Sélectionner'}}"></p-button>

                                <p-button *ngIf="estAutorise('item_detail')" icon="pi pi-bars" severity="secondary"
                                    (click)="surMenuContextuelItem($event, item)"></p-button>
                            </p-buttonGroup>
                            <p-menu #menuContextuelItem popup="popup" appendTo="body"
                                [model]="contenuMenuContextuelItem"></p-menu>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="colonnesSelectionnees.length + 4">
                            <div class="flex flex-column align-items-center justify-content-center py-6">
                                <span class="flex align-items-center justify-content-center"
                                    style="width:64px; height:64px; background:var(--body-bg); border-radius:50%;">
                                    <i class="pi pi-search" style="font-size:2rem;"></i>
                                </span>
                                <h5 class="font-bold text-lg mb-2">Aucun item trouvé</h5>
                                <small class="mb-4">Nous n'avons pas trouvé d'item correspondant à votre
                                    recherche.</small>
                                <div class="flex flex-column gap-2 w-full md:w-auto">
                                    <p-button type="button" label="Nouvel item" styleClass="w-full md:w-20rem"
                                        pTooltip="Créer un nouvel item inventorié" severity="success"
                                        (onClick)="nouvelItem($event)">
                                    </p-button>
                                    <p-button type="button" label="Nouvel item non-inventorié (Divers)"
                                        styleClass="w-full md:w-20rem" outlined
                                        (onClick)="ajouterItemDivers(dt.filters.global.value)">
                                    </p-button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!------------ NUMÉRO/DESCRIPTION ------------>

    <div class="fluid formgrid grid" *ngIf="itemSelectionne">
        <p-panel header="Item sélectionné ({{typeSaisieInventaire() ? 'inventorié' : 'non-inventorié'}})"
            class="col-12 mb-4">
            <div class="flex flex-wrap gap-2 justify-content-between align-items-center w-full">
                <div class="sihc-field flex flex-column gap-2">
                    <div class="flex align-items-center gap-2">
                        <div *ngIf="selectionItem?.photoId">
                            @defer (on viewport) {
                            <app-image-loader [documentId]="selectionItem.photoId" [width]="45" [height]="45"
                                [title]="selectionItem.numero"></app-image-loader>
                            }
                            @placeholder {
                            <div class="flex align-items-center justify-content-center"
                                style="height: 45px; width: 45px;">
                                <p-skeleton width="45px" height="45px"></p-skeleton>
                            </div>
                            }
                        </div>
                        <div class="flex flex-column gap-2">
                            <span class="champConsultation font-bold">{{selectionItem.numero || 'N/A'}}</span>
                            <span class="champConsultation">{{selectionItem.description | valeurVide}}</span>
                            <small class="p-error" *ngIf="submitted && !selectionItem.description">La description
                                est
                                obligatoire.</small>
                        </div>
                    </div>
                </div>
                @if (!donnees.item) {
                <div>
                    <p-buttonGroup>
                        <p-button *ngIf="typeSaisieDivers()" label="Renommer" icon="pi pi-pencil"
                            (click)="ajouterItemDivers(selectionItem.description)"></p-button>
                        <p-button *ngIf="!donnees.item" label="Changer" icon="pi pi-sync"
                            (click)="RechercherItem()"></p-button>
                        <p-button *ngIf="typeSaisieInventaire()" label="Voir la fiche" icon="pi pi-external-link"
                            severity="secondary"
                            (click)="OuvrirDetailItemNouvelOnglet(selectionItem.itemId)"></p-button>
                        <p-button *ngIf="typeSaisieInventaire()" label="Cloner" icon="pi pi-fw pi-clone"
                            severity="secondary" (click)="dupliquerItem(selectionItem)"></p-button>
                    </p-buttonGroup>
                    <p-menu #menuContextuelReleve popup="popup" appendTo="body" [model]="contenuMenuContextuelReleve">
                    </p-menu>
                </div>
                }
            </div>
        </p-panel>
        <div *ngIf="donnees.indCommande" class="flex flex-column gap-2 my-2 col-12">
            <label>&nbsp;</label>
            <p-message styleClass="w-full" severity="info" [text]="'Cet item est ajouté à une commande.'"></p-message>
        </div>
    </div>

    <!------------ RETOUR EXPRESS ------------>

    <div *ngIf="(estTypeCommande() || estTypeRequisition()) &&
                selectionTypeSaisie.cle == 'I' 
                && selectionItem && selectionItem.emplacement && selectionItem.emplacement.emplacementId != emplacementIdVerificationTransfertExpress
                && selectionItem.categorie.estUnique" class="my-2">
        <p-messages severity="warn">
            <ng-template pTemplate>
                <div class="flex flex-column gap-2 w-full">
                    <div class="flex flex-column gap-2 w-full mb-2">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-exclamation-triangle " style="color:#dd8500; font-size: 1.4rem"></i>
                            <h5 class="m-0">Ajustement d'inventaire</h5>
                        </div>
                        <span>L'emplacement actuel de l'item ne permet pas le déplacement. Un retour/transfert
                            automatique
                            sera
                            effectué en date du:</span>
                    </div>
                    <div class="flex flex-column gap-2 w-full">
                        <p-calendar appendTo="body" showIcon=true [(ngModel)]="dateRetourAuto" dateFormat="yy-mm-dd"
                            [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
                    </div>
                </div>
            </ng-template>
        </p-messages>
    </div>

    <!------------ CHAMPS SPÉCIFIQUES ------------>

    <div class="fluid formgrid grid" *ngIf="itemSelectionne">
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3"
            *ngIf="estTypePreCommande() || estTypeCommande() || estTypeRequisition()">
            <label for="demandeur" class="font-medium">Demandeur<span class="requis">*</span></label>
            <p-dropdown #champDemandeur [options]="listeEmployes" [(ngModel)]="selectionDemandeur" optionLabel="nom"
                [showClear]="true" (onHide)="surFermetureDemandeur()" filter="true" filterBy="prenom,nom"
                appendTo="body" placeholder="Sélectionner un demandeur..." styleClass="w-full"
                panelStyleClass="p-dropdown-panel-mobile">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionDemandeur" class="text-sm md:text-base">
                        <div>{{selectionDemandeur.prenom}} {{selectionDemandeur.nom}}</div>
                    </div>
                </ng-template>
                <ng-template let-employe pTemplate="item">
                    <div class="text-sm md:text-base p-2">
                        <div>{{employe.prenom}} {{employe.nom}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error" *ngIf="submitted && !selectionDemandeur">Le demandeur est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3"
            *ngIf="itemSelectionne && selectionItem?.categorie?.categorieId == 6 && (estTypePreCommande() || estTypeCommande() || estTypeRequisition())">
            <label for="unite">Unité</label>
            <p-dropdown #champDemandeur [options]="listeUnites" [(ngModel)]="selectionUnite" optionLabel="description"
                [showClear]="true" filter="true" filterBy="numero,description,marque,modele" appendTo="body"
                placeholder="Sélectionner une unité...">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionUnite">
                        <div>{{selectionUnite.numero}} {{selectionUnite.description}}</div>
                    </div>
                </ng-template>
                <ng-template let-unite pTemplate="item">
                    <div>
                        <div>{{unite.numero}} {{unite.description}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="quantity" class="font-medium">Quantité<span class="requis">*</span></label>
            <p-inputGroup>
                <p-inputNumber autofocus *ngIf="!estTypeBonCommande()" #champQuantite [(ngModel)]="quantiteDemande"
                    [disabled]="typeSaisieInventaire() && selectionItem && selectionItem.categorie.estUnique"
                    class="w-1">
                </p-inputNumber>
                <p-inputNumber autofocus *ngIf="estTypeBonCommande()" #champQuantite [(ngModel)]="quantiteDemande"
                    [minFractionDigits]="2" [maxFractionDigits]="2" locale="en-US"
                    [disabled]="typeSaisieInventaire() && selectionItem && selectionItem.categorie.estUnique"
                    class="w-1">
                </p-inputNumber>
                <input *ngIf="estTypeBonCommande()" type="text" placeholder="Unité de mesure" pInputText
                    [(ngModel)]="uniteQte" />
            </p-inputGroup>
            <small class="p-error" *ngIf="submitted && !quantiteDemande">La quantité est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3" *ngIf="estTypeBonCommande()">
            <label for="prix" class="font-medium">Prix<span class="requis">*</span></label>
            <p-inputNumber #champPrix [(ngModel)]="prix" mode="currency" currency="USD" locale="en-US"
                [minFractionDigits]="4" [maxFractionDigits]="4" inputStyleClass="w-full" styleClass="w-full">
            </p-inputNumber>
            <small class="p-error" *ngIf="submitted && !prix && prix != 0">Le prix est obligatoire.</small>
        </div>
        @if (afficherChampCout()) {
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="cout" class="font-medium">Coût</label>
            <p-inputNumber inputId="cout" [(ngModel)]="cout" mode="currency" currency="CAD" locale="fr-CA"
                [minFractionDigits]="2" [maxFractionDigits]="2" inputStyleClass="w-full" styleClass="w-full">
            </p-inputNumber>
        </div>
        }
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3" *ngIf="estTypeBonCommande()">
            <label for="noFournisseur" class="font-medium">No pièce fournisseur</label>
            <input #champNoFournisseur type="text" pInputText id="noFournisseur" [(ngModel)]="noFournisseur"
                autocomplete="off" class="w-full" />
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3" *ngIf="estTypeCommande()">
            <label for="dateDemande" class="font-medium">Date de demande<span class="requis">*</span></label>
            <p-calendar appendTo="body" showIcon=true [(ngModel)]="dateDemande" dateFormat="yy-mm-dd"
                [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" styleClass="w-full"
                inputStyleClass="w-full" [touchUI]="true">
            </p-calendar>
            <small class="p-error" *ngIf="submitted && !dateDemande">La date de demande est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3"
            *ngIf="estTypePreCommande() || estTypeCommande()">
            <label for="dateRequis" class="font-medium">Date requise</label>
            <p-calendar appendTo="body" showIcon=true [(ngModel)]="dateRequis" dateFormat="yy-mm-dd"
                [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" styleClass="w-full"
                inputStyleClass="w-full" [touchUI]="true" placeholder="Lors du prochain transport réalisable">
            </p-calendar>
        </div>
    </div>

    <!------------ BONS DE COMMANDE / PRECOMMANDES - CODES ------------>

    <div class="fluid formgrid grid" *ngIf="(estTypeBonCommande() || estTypePreCommande()) && (itemSelectionne)">
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="codeProjet" class="font-medium">Code projet<span class="requis">*</span></label>
            <p-dropdown #champCodeProjet [options]="listeCodeProjet" [(ngModel)]="selectionCodeProjet"
                optionLabel="code" [showClear]="true" (onHide)="surFermetureCodeProjet()" filter="true"
                filterBy="code,nom" (onChange)="surChangementCodeProjet()" appendTo="body"
                placeholder="Sélectionner un code de projet..." styleClass="w-full"
                panelStyleClass="p-dropdown-panel-mobile">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionCodeProjet" class="text-sm md:text-base">
                        <div>{{selectionCodeProjet.code}}</div>
                    </div>
                </ng-template>
                <ng-template let-code pTemplate="item">
                    <div class="text-sm md:text-base p-2">
                        <div>{{code.code}} - {{code.nom}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error" *ngIf="submitted && !selectionCodeProjet">Le code de projet est
                obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="codeActivite">Code d'activité<span *ngIf="estCodeCategorieObligatoire"
                    class="requis">*</span></label>
            <p-dropdown #champCodeActivite [options]="listeCodeActivite" [(ngModel)]="selectionCodeActivite"
                optionLabel="code" [disabled]="!selectionCodeProjet" (onChange)="surChangementCodeActivite()"
                [showClear]="true" (onHide)="surFermetureCodeActivite()" filter="true" filterBy="code,nom"
                appendTo="body" placeholder="Sélectionner un code d'activité...">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionCodeActivite">
                        <div>{{selectionCodeActivite.code}}</div>
                    </div>
                </ng-template>
                <ng-template let-code pTemplate="item">
                    <div>
                        <div>{{code.code}} - {{code.nom}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error" *ngIf="submitted && estCodeActiviteObligatoire && !selectionCodeActivite">Le code
                d'activité est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="codeCategorie">Catégorie de coût<span *ngIf="estCodeCategorieObligatoire"
                    class="requis">*</span></label>
            <p-dropdown #champCodeCategorie [options]="listeCodeCategorie" [(ngModel)]="selectionCodeCategorie"
                optionLabel="code" [disabled]="!selectionCodeProjet || codeCategorieBloque" [showClear]="true"
                filter="true" filterBy="code,nom" appendTo="body" placeholder="Sélectionner une catégorie de coût...">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionCodeCategorie">
                        <div>{{selectionCodeCategorie.code}}</div>
                    </div>
                </ng-template>
                <ng-template let-code pTemplate="item">
                    <div>
                        <div>{{code.code}} - {{code.nom}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error" *ngIf="submitted && estCodeCategorieObligatoire && !selectionCodeCategorie">La
                catégorie de coût est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="emplacement">Emplacement</label>
            <p-dropdown #champEmplacement [options]="listeEmplacement" [(ngModel)]="selectionEmplacement"
                optionLabel="code" [showClear]="true" filter="true" filterBy="code,nom" appendTo="body"
                placeholder="Sélectionner un emplacement..">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionEmplacement">
                        <div>{{selectionEmplacement.code}}</div>
                    </div>
                </ng-template>
                <ng-template let-emplacement pTemplate="item">
                    <div>
                        <div>{{emplacement | nomEmplacement}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="codeCategorie">Équipement<span
                    *ngIf="selectionCodeProjet?.code == 'ENTRET' && selectionCodeActivite?.code == '280'"
                    class="requis">*</span></label>
            <p-dropdown #champCodeEquipement [options]="listeCodeEquipement" [(ngModel)]="selectionCodeEquipement"
                optionLabel="code" [disabled]="codeEquipementBloque" [showClear]="true" filter="true"
                filterBy="code,nom" (onChange)="surChangementCodeEquipement()" appendTo="body"
                placeholder="Sélectionner un équipement..">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionCodeEquipement">
                        <div>{{selectionCodeEquipement.code}}</div>
                    </div>
                </ng-template>
                <ng-template let-code pTemplate="item">
                    <div>
                        <div>{{code.code}} - {{code.nom}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error"
                *ngIf="submitted && selectionCodeProjet?.code == 'ENTRET' && selectionCodeActivite?.code == '280' && !selectionCodeEquipement">La
                catégorie de coût est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
            <label for="codeCategorie">Extra <span class="requis"
                    *ngIf="selectionCodeProjet?.code == 'CLIENT' && selectionCodeActivite?.code == 'CM'">*</span></label>
            <p-dropdown #champCodeExtra [options]="listeCodeExtra" [(ngModel)]="selectionCodeExtra" optionLabel="code"
                [showClear]="true" filter="true" filterBy="code,nom" virtualScroll [virtualScrollItemSize]="33"
                appendTo="body" placeholder="Sélectionner un extra.."
                [required]="selectionCodeProjet?.code == 'CLIENT' && selectionCodeActivite?.code == 'CM'">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionCodeExtra">
                        <div>{{selectionCodeExtra.code}}</div>
                    </div>
                </ng-template>
                <ng-template let-code pTemplate="item">
                    <div>
                        <div>{{code.code}} - {{code.nom}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error"
                *ngIf="submitted && selectionCodeProjet?.code == 'CLIENT' && selectionCodeActivite?.code == 'CM' && !selectionCodeExtra">L'extra
                est obligatoire.</small>
        </div>
    </div>

    <!------------ NOTE ------------>
    <div class="fluid formgrid grid" *ngIf="estTypePreCommande() && itemSelectionne">
        <div class="flex flex-column gap-2 my-2 col-12">
            <label for="note" class="font-medium">Note</label>
            <textarea #champNote pInputText id="note" [(ngModel)]="note" autocomplete="off" rows="3" class="w-full"
                style="min-height: 3rem; resize: vertical;"></textarea>
        </div>
    </div>

    <!------------ COMMANDE ------------>
    <div class="fluid formgrid grid" *ngIf="estTypeBonCommande() && itemSelectionne && !donnees.indCommande">

        <div class="flex flex-column gap-2 my-2 col-12">
            <label for="lastname">Voulez-vous créer une commande pour cet item? <i class="pi pi-info-circle"
                    pTooltip="Une commande avise l'approvisionnement que cet item doit être livré à l'emplacement de destination sélectionné (Vous pouvez accéder aux commandes à partir de l'emplacement de destination sélectionné)"></i></label>
            <p-checkbox [binary]="true" [(ngModel)]="indAjoutCommande"></p-checkbox>
        </div>

        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3" *ngIf="indAjoutCommande">
            <label for="demandeur">Demandeur<span class="requis">*</span></label>
            <p-dropdown #champDemandeur [options]="listeEmployes" [(ngModel)]="selectionDemandeur" optionLabel="nom"
                [showClear]="true" (onHide)="surFermetureDemandeur()" filter="true" filterBy="prenom,nom"
                appendTo="body" placeholder="Sélectionner un demandeur...">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionDemandeur">
                        <div>{{selectionDemandeur.prenom}} {{selectionDemandeur.nom}}</div>
                    </div>
                </ng-template>
                <ng-template let-employe pTemplate="item">
                    <div>
                        <div>{{employe.prenom}} {{employe.nom}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error" *ngIf="submitted && !selectionDemandeur">Le demandeur est obligatoire.</small>
            <!-- <input #champDemandeur type="text" pInputText id="demandeur" [(ngModel)]="demandeur" autocomplete="off"
                 /> -->
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3" *ngIf="indAjoutCommande">
            <label for="emplacement">Commande<span class="requis">*</span></label>
            <p-dropdown #champEmplacement [options]="listeEmplacementAjoutCommande"
                [(ngModel)]="selectionEmplacementAjoutCommande" optionLabel="code" [showClear]="true" filter="true"
                filterBy="code,nom" appendTo="body" placeholder="Sélectionner un emplacement..">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionEmplacementAjoutCommande">
                        <div>{{selectionEmplacementAjoutCommande.code}}</div>
                    </div>
                </ng-template>
                <ng-template let-emplacement pTemplate="item">
                    <div>
                        <div>{{emplacement | nomEmplacement}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <small class="p-error" *ngIf="submitted && !selectionEmplacementAjoutCommande">La commande est
                obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-2" *ngIf="indAjoutCommande">
            <label for="dateDemande">Date de demande<span class="requis">*</span></label>
            <p-calendar appendTo="body" showIcon=true [(ngModel)]="dateDemande" dateFormat="yy-mm-dd"
                [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"
                (onSelect)="surChangementDateDemande($event)"></p-calendar>
            <small class="p-error" *ngIf="submitted && !dateDemande">La date de demande est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-2" *ngIf="indAjoutCommande">
            <label for="dateRequis">Date requise<span class="requis">*</span></label>
            <p-calendar appendTo="body" showIcon=true [(ngModel)]="dateRequis" dateFormat="yy-mm-dd"
                [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>

            <small class="p-error" *ngIf="submitted && !dateRequis">La date requise est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3" *ngIf="indAjoutCommande">
            <label for="unite">Unité</label>
            <p-dropdown [options]="listeUnites" [(ngModel)]="selectionUniteAjoutCommande" optionLabel="description"
                [showClear]="true" filter="true" filterBy="numero,description,marque,modele" appendTo="body"
                placeholder="Sélectionner une unité...">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="selectionUniteAjoutCommande">
                        <div>{{selectionUniteAjoutCommande.numero}} {{selectionUniteAjoutCommande.description}}
                        </div>
                    </div>
                </ng-template>
                <ng-template let-unite pTemplate="item">
                    <div>
                        <div>{{unite.numero}} {{unite.description}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>

    <!------------ ASSOCIATIONS PIÈCES MÉCANIQUES ------------>

    <div *ngIf="estTypeBonCommande()
        && selectionTypeSaisie.cle == 'I' 
        && selectionItem
        && selectionItem.categorie
        && selectionItem.categorie.categorieId == 6
        && selectionCodeEquipement
        && estAutorise('piece_associer')" class="fluid formgrid grid mt-2">
        <div class="flex flex-column gap-2 my-2 col-12 md:col-6">
            <label for="lastname">Voulez-vous associer la pièce {{selectionItem.description}} à l'unité
                {{selectionItem.numero}} {{selectionItem.description}} ?</label>
            <div class="flex align-items-center gap-2">
                <p-inputSwitch [(ngModel)]="indAssocier" />
                <p-dropdown [options]="listeCategoriesEntretienAvecDefaut" [(ngModel)]="selectionCategorieEntretien"
                    [showClear]="false" optionLabel="description" filter="true" filterBy="code,description"
                    [disabled]="!indAssocier" appendTo="body" (onChange)="surChangementCategorieEntretien($event)"
                    placeholder="Sélectionner une catégorie...">
                    <ng-template pTemplate="selectedItem">
                        <div *ngIf="selectionCategorieEntretien">
                            <div>{{selectionCategorieEntretien.code}} -
                                {{selectionCategorieEntretien.description}}
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="selectedItem">
                        <div [class.disabled-category]="estCategorieDejaAssociee(selectionCategorieEntretien)"
                            [class.enabled-category]="!estCategorieDejaAssociee(selectionCategorieEntretien)">
                            <div>
                                <span
                                    [style]="{'text-decoration': estCategorieDejaAssociee(selectionCategorieEntretien) ? 'line-through' : 'none'}">{{selectionCategorieEntretien.code}}
                                    - {{selectionCategorieEntretien.description}}</span>
                                <span *ngIf="estCategorieDejaAssociee(selectionCategorieEntretien)"
                                    class="ml-2 text-sm text-muted">
                                    (Categorie déjà associée)
                                </span>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-categorie pTemplate="item">
                        <div [class.disabled-category]="estCategorieDejaAssociee(categorie)"
                            [class.enabled-category]="!estCategorieDejaAssociee(categorie)">
                            <div [style]="{'cursor': estCategorieDejaAssociee(categorie) ? 'not-allowed' : 'pointer'}">
                                <span
                                    [style]="{'text-decoration': estCategorieDejaAssociee(categorie) ? 'line-through' : 'none'}">{{categorie.code}}
                                    - {{categorie.description}}</span>
                                <span *ngIf="estCategorieDejaAssociee(categorie)" class="ml-2 text-sm text-muted">
                                    (Categorie déjà associée)
                                </span>
                            </div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
    </div>
</div>

<!------------ BOUTONS ------------>

<div class="flex flex-column md:flex-row gap-3 md:gap-2 justify-content-center md:justify-content-end mt-4"
    *ngIf="!typeSaisieInventaire() || itemSelectionne">
    <button pButton pRipple [label]="donnees.item ? 'Modifier' : 'Ajouter'" icon="pi pi-check"
        class="p-button-primary w-full md:w-auto order-1 md:order-2" (click)="selectionner()"></button>
    <button pButton pRipple label="Annuler" icon="pi pi-times"
        class="p-button-outlined w-full md:w-auto order-2 md:order-1" (click)="annuler()"></button>
</div>

<p-confirmDialog #confirmDialogItemDivers key="itemDiversConfirmation" appendTo="body">
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-column gap-2 p-3">
            <p>Veuillez fournir la description de l'item</p>
            <input autofocus type="text" (ngModelChange)="tempItemDiversDescription = $event; search($event)"
                [ngModel]="message.message" placeholder="Description" class="w-full" pInputText
                (keyup.enter)="tempItemDiversDescription?.trim() && confirmDialogItemDivers.accept()" />
            <br>
            <small class="text-muted">Êtes-vous certains que l'item n'existe pas dans l'inventaire:</small>
            <p-listbox [options]="suggestions" [(ngModel)]="selectionItem" optionLabel="label"
                [style]="{ width: '30rem' }" [metaKeySelection]="false"
                (onChange)="surSelectionItemInventaire($event.value); confirmDialogItemDivers.reject()"
                scrollHeight="250px">
                <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        @if (selectionItem?.photoId) {
                        @defer (on viewport) {
                        <app-image-loader [documentId]="selectionItem.photoId" [width]="45" [height]="45"
                            [title]="selectionItem.numero"></app-image-loader>
                        }
                        @placeholder {
                        <div class="flex align-items-center justify-content-center" style="height: 45px; width: 45px;">
                            <p-skeleton width="45px" height="45px"></p-skeleton>
                        </div>
                        }
                        }
                        <div class="flex flex-column gap-2">
                            <div class="font-bold">{{item.numero}} {{item.description}}</div>
                            <div class="text-sm">{{item.modele}}</div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="empty">
                    <div class="flex align-items-center justify-content-center w-full h-full">
                        <span>Aucun item trouvé</span>
                    </div>
                </ng-template>
            </p-listbox>
            <div class="flex gap-2 justify-content-end mt-3">
                <p-button label="Annuler" icon="pi pi-times" [outlined]="true"
                    (onClick)="confirmDialogItemDivers.reject()"></p-button>
                <p-button label="Prochaine étape" icon="pi pi-check" [disabled]="!tempItemDiversDescription?.trim()"
                    (onClick)="confirmDialogItemDivers.accept()"></p-button>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>

<p-sidebar [(visible)]="afficherDetailItem" [style]="{width:'95%'}" position="left">
    <app-detail-item [itemId]="detailItemId" *ngIf="afficherDetailItem"></app-detail-item>
</p-sidebar>